<template>
  <div class="navigator-top-container">
    <div class="navigator-main">
      <div class="nav-logo" />
      <div
        v-for="item in navLists.filter(nav => nav.value !== 'Share')"
        :key="item.value"
        class="nav-item"
        @click="scrollTo(item.value)"
        v-rseat="`click_carnival_nav_${item.value}`"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
<script>
const DELTA = 112

export default {
  props: {
    navLists: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeItem: '',
    }
  },
  methods: {
    scrollTo(active) {
      this.activeItem = active
      this.isShowQr = false
      if (active === 'goIndex') {
        this.goPage('IFC2021')
      } else if (active === 'SWHZ') {
        this.goPage('IFC2021-cooperate')
      } else if (active === 'GGHZ') {
        this.goGGHZ()
      } else {
        const navContent = document.querySelectorAll(`[data-anchor="${active}"]`)[0]
        const cityTab = document.querySelector('[data-city-tab]')
        const cityTabHeight = cityTab ? cityTab.offsetHeight : DELTA
        const scrollHei = navContent.offsetTop - cityTabHeight
        if (navContent) {
          window.scrollTo({
            top: scrollHei,
            behavior: 'smooth',
          })
        }
      }
    },
    goPage(name) {
      this.$router.push(
        {
          name,
        },
        () => {
          document.body.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
        },
      )
    },
    goGGHZ() {
      window.open('https://www.iqiyi.com/marketing/m.gghz.html')
    },
  },
}
</script>
<style lang="less" scoped>
.navigator-top-container {
  position: absolute;
  top: 0;
  background-color: transparent;
  box-sizing: border-box;
  width: 100%;
  max-width: 192rem;
  margin: 0 auto;
  height: 8.7rem;
  background: transparent url('../images/header-bg.png') top center no-repeat;
  background-size: 192rem auto;
  .navigator-main {
    position: relative;
    display: flex;
    align-items: center;
    max-width: 100.9rem;
    height: 7.5rem;
    margin: 0 auto;
  }
  .nav-logo {
    width: 15.6rem;
    height: 6.2rem;
    background: transparent url('../images/header-logo.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .nav-item {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    width: 7.2rem;
    margin-left: 5.9rem;
    font-size: 1.8rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    line-height: 2.6rem;
    cursor: pointer;
    &.cur {
      position: relative;
      color: #4adafe;
      &::after {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        bottom: -1.8rem;
        display: inline-block;
        content: '';
        border-width: 0 1rem 1.2rem;
        border-style: solid;
        border-color: transparent transparent #fab9f9;
      }
    }
  }
}
</style>
